import(/* webpackMode: "eager" */ "/opt/sophia-shopper/landing/app/me/data/page.tsx");
